import React, { ReactNode } from "react";
import { Modal } from "antd";
import Title from "antd/es/typography/Title";

interface Props {
  children: React.ReactNode;
  open?: boolean;
  onClose: Function;
  title?: string | ReactNode;
  titleComponent?: React.ReactNode;
  className?: string;
  size?: "xl" | "l" | "md" | "sm";
  closeIcon?: boolean;
  bodyStyle?: React.CSSProperties;
}

const CustomModal = (props: Props) => {
  const {
    onClose,
    children,
    open,
    title,
    size,
    titleComponent,
    closeIcon,
    bodyStyle,
  } = props;
  let widthClass = "!w-2/5 !max-w-3xl";
  const handleOk = () => {
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };

  const modalStyles: {
    mask?: React.CSSProperties;
    content?: React.CSSProperties;
    body?: React.CSSProperties;
  } = {
    mask: {
      backgroundColor: "rgba(0, 0, 0, 0.77)",
    },
  };
  if (bodyStyle) {
    modalStyles.content = {
      maxHeight: "85vh",
      overflow: "hidden",
      display: "flex",
      flexDirection: "column",
    };
    modalStyles.body = {
      ...bodyStyle,
      flex: 1,
      minHeight: 0,
      overflow: "hidden",
    };
  }
  if (size === "xl") {
    widthClass = "!w-4/5 !max-w-screen-2xl";
  } else if (size === "l") {
    widthClass = "!w-3/5 !max-w-6xl";
  } else if (size === "sm") {
    widthClass = "!w-1/5 !max-w-sm";
  }
  return (
    <>
      <Modal
        className={`${widthClass} max-sm:!w-full sm:!w-full`}
        title={
          titleComponent ? titleComponent : <Title level={1}>{title}</Title>
        }
        open={open}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[]}
        maskClosable={false}
        styles={modalStyles}
        closeIcon={closeIcon ?? true}
        bodyStyle={bodyStyle && !modalStyles.body ? bodyStyle : undefined}
      >
        {children}
      </Modal>
    </>
  );
};

export default CustomModal;
